import { render, staticRenderFns } from "./Paid.vue?vue&type=template&id=5a273d96&"
import script from "./Paid.vue?vue&type=script&lang=js&"
export * from "./Paid.vue?vue&type=script&lang=js&"
import style0 from "./Paid.vue?vue&type=style&index=0&id=5a273d96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports